import { PolicyComponentConfiguration } from "@idw-types/data/policy-component-configuration/policy-component-configuration";

export enum PolicyComponentsActionTypes {
    // Policy Components
    SET_POLICY_COMPONENTS_LOADING = "SET_POLICY_COMPONENTS_LOADING",
    SET_POLICY_COMPONENTS = "SET_POLICY_COMPONENTS",
    ADD_POLICY_COMPONENT = "ADD_POLICY_COMPONENT"
}

// Policy Components
type SetPolicyComponentsLoadingAction = {
    type: PolicyComponentsActionTypes.SET_POLICY_COMPONENTS_LOADING;
    payload: { isLoading: boolean; }
};

export const setPolicyComponentsLoading = (isLoading: boolean): SetPolicyComponentsLoadingAction => ({
    type: PolicyComponentsActionTypes.SET_POLICY_COMPONENTS_LOADING,
    payload: { isLoading }
});

type SetPolicyComponentsAction = {
    type: PolicyComponentsActionTypes.SET_POLICY_COMPONENTS;
    payload: { policyComponents: Array<PolicyComponentConfiguration>; }
}

export const setPolicyComponents = (policyComponents: Array<PolicyComponentConfiguration>): SetPolicyComponentsAction => ({
    type: PolicyComponentsActionTypes.SET_POLICY_COMPONENTS,
    payload: { policyComponents }
});

type AddPolicyComponentAction = {
    type: PolicyComponentsActionTypes.ADD_POLICY_COMPONENT;
    payload: { policyComponent: PolicyComponentConfiguration };
}

export const addPolicyComponent = (policyComponent: PolicyComponentConfiguration): AddPolicyComponentAction => ({
    type: PolicyComponentsActionTypes.ADD_POLICY_COMPONENT,
    payload: { policyComponent }
});

export type PolicyComponentsActions =
    // Policy Components
    SetPolicyComponentsLoadingAction |
    SetPolicyComponentsAction |
    AddPolicyComponentAction